import * as React from "react"
import { Button } from "@chakra-ui/react"
import { HomeSubmitButtonProps } from "./home.interface"
import { useTranslation } from "react-i18next"
import { useLocalUserType } from "../../../hooks/useLocalUserType"

const _HomeSubmitButton: React.FC<HomeSubmitButtonProps> = ({
  loading,
  roomStyles,
  joinMeeting,
  isMicCamRequired
}) => {
  const { t } = useTranslation()
  const { isAudience } = useLocalUserType()

  const joinButtonText =  isAudience ? roomStyles?.joinPageButtonTextForAudience || t("Watch") : t("Enter")

  return (
    <Button
      isLoading={loading}
      loadingText={isAudience ? t("Joining...") : t("Entering...")}
      bg={roomStyles?.joinButtonBackgroundColor ?? "#1AC541"}
      border={
        roomStyles?.joinButtonBorderColor
          ? `1px solid ${
              roomStyles?.joinButtonBorderColor
                ? roomStyles.joinButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={roomStyles?.joinPageButtonTextColor ?? "#FFFFFF"}
      _hover={{
        backgroundColor:
          roomStyles?.joinButtonMouseoverBackgroundColor ?? "#24A840",
        textColor: roomStyles?.joinPageButtonMouseoverTextColor ?? "#FFFFFF",
        borderColor: roomStyles?.joinButtonBorderMouseoverColor ?? null,
      }}
      borderRadius={roomStyles?.joinButtonBorderRadius}
      _focus={{}}
      _active={{}}
      _disabled={{ opacity: 0.25 }}
      onClick={loading ? undefined : joinMeeting}
      // disabled={disableJoinButton()}
    >
     {joinButtonText}
    </Button>
  )
}

export const HomeSubmitButton = React.memo(_HomeSubmitButton)
